/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const financialsPipelineEntryDtoSchema = z.object({
  name: z.optional(z.string()),
  amount: z.optional(z.string()),
  tone: z.optional(z.string()),
  sub: z.optional(z.string()),
});
